import React, { Fragment } from 'react';
import Offer from './offer';
import ListModel from 'Stores/ListModel';
import OfferModel from 'Stores/OfferModel';
import IntroText from 'Components/IntroText';
import styles from './styles.scss';

const OfferList = (props) => {
  const { offerList } = props;

  const offerListModel = new ListModel(offerList, OfferModel);

  if (offerListModel.items.length === 0) {
    return (
      <IntroText
        headline={{
          level: 'h2',
          value: 'Zurzeit sind keine Angebote vorhanden',
          forceUppercase: true,
        }}
      />
    );
  }

  return offerListModel.items.reduce(
    (acc, offer, i) => [
      ...acc,
      <Fragment key={offer.id}>
        {i > 0 && <div className={styles.separator} />}
        <Offer {...props} offer={offer} id={`offer-${offer.parentId || offer.id}`} />
      </Fragment>,
    ],
    []
  );
};

export default OfferList;
